const initialData = {
  forSomeone: false,
  name: null,
  introduction: null,
  reason: null,
  gender: null,
  instruction: null,
  athleteId: null,
  amount: null,
  currency: null,
  confirmModalVisible: false
};

const requestShoutout = (state = initialData, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'UPDATE_REQUEST_SHOUTOUT_FORM':
      return { ...state, [payload.prop]: payload.value };
    case 'RESET_INITIAL_DATA':
      return initialData;
    case 'RESET_FORM':
      return {
        ...state,
        introduction: null,
        reason: null,
        gender: null,
        instruction: null
      };
    case 'SHOW_CONFIRM_MODAL':
      return { ...state, confirmModalVisible: payload.visible };
    default:
      return state;
  }
};

export default requestShoutout;
